
import { Component, Vue } from "vue-property-decorator";
import { AppMain, Sidebar, Header } from "./components";
import api from "@/api";
import store from "@/store";
@Component({
  name: "Layout",
  components: {
    Header,
    AppMain,
    Sidebar,
  },
})
export default class Layout extends Vue {
  count = 0
  timer: any
  getEmailCount() {
      api.post("A16004", { user_id: store.state.user.user.id }).then((res) => {
        this.count = res
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.getEmailCount()
        }, 300000 );
      });

  }

  getNoiceNum() {
    //先清除定时器
    clearInterval(this.timer)
    // this.getEmailCount()
  }

  created() {
    this.getNoiceNum()
  }
}
